export const cybersecurityConst = {
  path: "/single-programs/cybersecurity",
  title: "ФАКУЛЬТЕТ ИТ И ИНЖЕНЕРИИ – КИБЕРБЕЗОПАСНОСТЬ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Кибербезопасность — профессия, защищающая цифровой мир</h2>
      <p>
        В цифровую эпоху безопасность информации стала приоритетом для бизнеса, государства и каждого пользователя. Специалисты по
        кибербезопасности находятся на передовой борьбы с хакерскими атаками, утечками данных и киберпреступностью. Эта программа готовит
        профессионалов, способных противостоять самым современным угрозам.
      </p>
      <p>
        Вы научитесь оценивать риски, строить защиту, проводить тесты на проникновение и работать с нормативными актами в сфере ИБ. Обучение
        совмещает теорию, практику и реальные кейсы.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы информационной безопасности</li>
        <li>Криптография и защита данных</li>
        <li>Этичный взлом (penetration testing)</li>
        <li>Анализ уязвимостей и защита сетей</li>
        <li>Системы мониторинга и обнаружения атак (SIEM)</li>
        <li>Киберугрозы и цифровая криминалистика</li>
        <li>Безопасность облачных технологий и DevSecOps</li>
        <li>Киберправо и соответствие международным стандартам (GDPR, ISO 27001)</li>
        <li>Социальная инженерия и защита от фишинга</li>
        <li>Практика в виртуальных лабораториях и симуляциях атак</li>
      </ul>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Специалист по информационной безопасности (InfoSec)</li>
        <li>Аналитик по киберугрозам (SOC-аналитик)</li>
        <li>Этичный хакер / Pentester</li>
        <li>Консультант по защите данных и GDPR</li>
        <li>Инженер по кибербезопасности в облаке</li>
        <li>Digital forensics-специалист</li>
        <li>Архитектор систем ИБ</li>
        <li>Руководитель службы информационной безопасности (CISO)</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€60,000 до €115,000 в год,</strong> в зависимости от специализации и уровня.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный работодателями по всему миру</li>
        <li>Курсы от практикующих специалистов ИБ и сертифицированных хакеров</li>
        <li>Доступ к симуляторам атак и защищенным лабораториям</li>
        <li>Программа соответствует требованиям международных сертификаций (CompTIA Security+, CEH, CISSP)</li>
        <li>Возможность учиться полностью онлайн без отрыва от работы</li>
        <li>Индивидуальное сопровождение на каждом этапе обучения</li>
        <li>Язык обучения — русский или английский</li>
      </ul>
      <p>Кибербезопасность — это не просто знания. Это ключ к защите будущего.</p>
      <h2>Как поступить?</h2>
      <p>Поступление — это просто! Приёмная комиссия поможет выбрать уровень программы, собрать документы и подать заявку.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Кибербезопасность — профессия, защищающая цифровой мир
    В цифровую эпоху безопасность информации стала приоритетом для бизнеса, государства и каждого пользователя. Специалисты по кибербезопасности находятся на передовой борьбы с хакерскими атаками, утечками данных и киберпреступностью. Эта программа готовит профессионалов, способных противостоять самым современным угрозам.
    Вы научитесь оценивать риски, строить защиту, проводить тесты на проникновение и работать с нормативными актами в сфере ИБ. Обучение совмещает теорию, практику и реальные кейсы.

    Что вы будете изучать?
    • Основы информационной безопасности
    • Криптография и защита данных
    • Этичный взлом (penetration testing)
    • Анализ уязвимостей и защита сетей
    • Системы мониторинга и обнаружения атак (SIEM)
    • Киберугрозы и цифровая криминалистика
    • Безопасность облачных технологий и DevSecOps
    • Киберправо и соответствие международным стандартам (GDPR, ISO 27001)
    • Социальная инженерия и защита от фишинга
    • Практика в виртуальных лабораториях и симуляциях атак

    Кем можно работать после окончания?
    • Специалист по информационной безопасности (InfoSec)
    • Аналитик по киберугрозам (SOC-аналитик)
    • Этичный хакер / Pentester
    • Консультант по защите данных и GDPR
    • Инженер по кибербезопасности в облаке
    • Digital forensics-специалист
    • Архитектор систем ИБ
    • Руководитель службы информационной безопасности (CISO)

    Средний доход в Европе:
    от €60,000 до €115,000 в год, в зависимости от специализации и уровня.

    Почему выбирают нас?
    • Европейский диплом, признанный работодателями по всему миру
    • Курсы от практикующих специалистов ИБ и сертифицированных хакеров
    • Доступ к симуляторам атак и защищенным лабораториям
    • Программа соответствует требованиям международных сертификаций (CompTIA Security+, CEH, CISSP)
    • Возможность учиться полностью онлайн без отрыва от работы
    • Индивидуальное сопровождение на каждом этапе обучения
    • Язык обучения — русский или английский

    Кибербезопасность — это не просто знания. Это ключ к защите будущего.

    Как поступить?
    Поступление — это просто! Приёмная комиссия поможет выбрать уровень программы, собрать документы и подать заявку.
  `,
};
